// export const serverUrl = `http://localhost:4000`;
export const serverUrl = window.location.origin;

const BC = require('../Json/Community/bc.json');
const MBC = require('../Json/Community/mbc.json');
const BCM = require('../Json/Community/bcm.json');
const SC = require('../Json/Community/sc.json');
const SCA = require('../Json/Community/sca.json');
const ST = require('../Json/Community/st.json');
const COMPUTER = require('../Json/computer.json');
const CIVIL = require('../Json/civil.json');
const CHEMICAL = require('../Json/chemical.json');
const ELECTRICAL = require('../Json/electrical.json'); 
const ELECTRONICS = require('../Json/electronics.json');
const LEATHER = require('../Json/leather.json');
const MECHANICAL = require('../Json/mechanical.json');
const MISCELLANEOUS = require('../Json/miscellaneous.json');
const MODERNOFFICE = require('../Json/modernoffice.json');
const PRINTING = require('../Json/printing.json');
const TEXTILE = require('../Json/textile.json');
const STATES = require('../Json/states.json');
const DISTRICTS = require('../Json/districts.json');
const DOTE_COLLEGES = require('../Json/dotecol.json');
const COLLEGE_ADDRESS = require('../Json/coladdress.json');
const BSC = require('../Json/bsc.json');

export {
    BC, MBC, BCM, BSC, CHEMICAL, CIVIL, COLLEGE_ADDRESS, COMPUTER, ELECTRICAL, ELECTRONICS, DISTRICTS, DOTE_COLLEGES, LEATHER, MECHANICAL, MISCELLANEOUS, MODERNOFFICE, PRINTING, TEXTILE, SC, SCA, ST, STATES
};

export const BRANCH =  new Map([
  ["BY", "BIO MEDICAL ENGINEERING  (SS)"],
  ["CE", "CIVIL  ENGINEERING "],
  ["CM", "COMPUTER SCIENCE AND ENGINEERING (SS)"],
  ["CS", "COMPUTER SCIENCE AND ENGINEERING"],
  ["EC", "ELECTRONICS AND COMMUNICATION ENGINEERING"],
  ["EE", "ELECTRICAL AND ELECTRONICS ENGINEERING"],
  ["EL", "Electronics Engineering (VLSI Design and Technology) (SS)"],
  ["EM", "ELECTRONICS AND COMMUNICATION ENGINEERING (SS)"],
  ["GI", "GEO INFORMATICS"],
  ["IE", "INDUSTRIAL ENGINEERING"],
  ["IM", "INFORMATION TECHNOLOGY (SS)"],
  ["MA", "MATERIAL SCIENCE AND ENGINEERING (SS)"],
  ["ME", "MECHANICAL ENGINEERING"],
  ["MI", "MINING ENGINEERING"],
  ["MN", "MANUFACTURING ENGINEERING"],
  ["PT", "PRINTING & PACKING TECHNOLOGY"],
  ["XC", "CIVIL ENGINEERING (TAMIL MEDIUM)"],
  ["XM", "MECHANICAL ENGINEERING (TAMIL MEDIUM)"],
  ["AP", "APPAREL TECHNOLOGY (SS)"],
  ["CH", "CHEMICAL  ENGINEERING "],
  ["CL", "CHEMICAL  ENGINEERING (SS)"],
  ["CR", "CERAMIC TECHNOLOGY (SS)"],
  ["FS", "FOOD TECHNOLOGY (SS)"],
  ["IB", "INDUSTRIAL BIO TECHNOLOGY"],
  ["IS", "INDUSTRIAL BIO TECHNOLOGY (SS)"],
  ["LE", "LEATHER TECHNOLOGY"],
  ["PM", "PHARMACEUTICAL TECHNOLOGY (SS)"],
  ["PP", "PETROLEUM ENGINEERING AND TECHNOLOGY (SS)"],
  ["TX", "TEXTILE TECHNOLOGY"],
  ["AE", "AERONAUTICAL ENGINEERING"],
  ["AT", "ARTIFICIAL INTELLIGENCE AND DATA SCIENCE (SS)"],
  ["AU", "AUTOMOBILE ENGINEERING"],
  ["EI", "ELECTRONICS AND INSTRUMENTATION ENGINEERING"],
  ["PR", "PRODUCTION ENGINEERING"],
  ["RA", "ROBOTICS AND AUTOMATION (SS)"],
  ["RP", "RUBBER AND PLASTIC TECHNOLOGY"],
  ["IT", "INFORMATION TECHNOLOGY"],
  ["MT", "METALLURGICAL ENGINEERING"],
  ["AS", "AUTOMOBILE ENGINEERING (SS)"],
  ["BS", "BIO TECHNOLOGY (SS)"],
  ["CG", "Computer Science and Engineering (Artificial Intelligence and Machine Learning) (SS)"],
  ["CN", "CIVIL  ENGINEERING (SS)"],
  ["ES", "ELECTRICAL AND ELECTRONICS (SANDWICH) (SS)"],
  ["FY", "FASHION TECHNOLOGY (SS)"],
  ["IY", "INSTRUMENTATION AND CONTROL ENGINEERING (SS)"],
  ["MF", "MECHANICAL ENGINEERING (SS)"],
  ["MS", "MECHANICAL ENGINEERING (SANDWICH) (SS)"],
  ["MY", "METALLURGICAL ENGINEERING (SS)"],
  ["PN", "PRODUCTION ENGINEERING (SS)"],
  ["PS", "PRODUCTION ENGINEERING (SANDWICH) (SS)"],
  ["TT", "TEXTILE TECHNOLOGY (SS)"],
  ["EY", "ELECTRICAL AND ELECTRONICS ENGINEERING (SS)"],
  ["CW", "Computer Science and Business System (SS)"],
  ["MG", "MECHATRONICS (SS)"],
  ["AD", "Artificial Intelligence and Data Science"],
  ["EV", "Electronics Engineering (VLSI Design and Technology)"],
  ["AM", "COMPUTER SCIENCE AND ENGINEERING (AI AND MACHINE LEARNING)"],
  ["BT", "BIO TECHNOLOGY"],
  ["CF", "COMPUTER SCIENCE AND ENGINEERING (DATA SCIENCE)"],
  ["CK", "Civil Engineering (Environmental Engineering)"],
  ["EF", "Electrical and Computer Engineering"],
  ["MB", "Mechanical Engineering (Automobile)"],
  ["MJ", "Mechanical and Smart Manufacturing"],
  ["PC", "PETRO CHEMICAL TECHNOLOGY"],
  ["PH", "PHARMACEUTICAL TECHNOLOGY"],
  ["CZ", "CIVIL AND STRUCTUTURAL ENGINEERING"],
  ["MM", "MECHANICAL ENGINEERING (MANUFACTURING)"],
  ["PA", "PLASTIC TECHNOLOGY"],
  ["HT", "HANDLOOM AND TEXTILE TECHNOLOGY"],
  ["CC", "CHEMICAL AND ELECTRO CHEMICAL  ENGINEERING (SS)"],
  ["CB", "COMPUTER SCIENCE AND BUSSINESS SYSTEM"],
  ["SC", "Computer Science and Engineering (Cyber Security)"],
  ["CO", "COMPUTER AND  COMMUNICATION ENGINEERING"],
  ["RM", "ROBOTICS AND AUTOMATION"],
  ["FD", "FOOD TECHNOLOGY "],
  ["AL", "Artificial Intelligence and Machine Learning"],
  ["CD", "COMPUTER SCIENCE AND DESIGN"],
  ["EA", "Electronics and Communication (Advanced Communication Technology)"],
  ["BM", "BIO MEDICAL ENGINEERING "],
  ["MD", "MEDICAL ELECTRONICS"],
  ["MU", "MECHANICAL AND AUTOMATION ENGINEERING"],
  ["MR", "MARINE ENGINEERING"],
  ["AG", "AGRICULTURAL ENGINEERING"],
  ["MZ", "Mechatronics Engineering"],
  ["PE", "PETROLEUM ENGINEERING"],
  ["CI", "Computer Science and Engineering (Internet of Things)"],
  ["AO", " AEROSPACE ENGINEERING"],
  ["FT", "FASHION TECHNOLOGY"],
  ["IX", "Electronic Instrumentation and Control Engineering"],
  ["CY", "Cyber Security"],
  ["IC", "INSTRUMENTATION AND CONTROL ENGINEERING"],
  ["XS", "COMPUTER SCIENCE AND ENGINEERING (TAMIL)"],
  ["SF", "Safety and Fire Engineering"],
  ["TC", "TEXTILE CHEMISTRY"],
  ["EX", "Electronics and Computer Engineering"],
  ["TS", "Computer Science and Technology"],
  ["PD", "PETRO CHEMICAL ENGINEERING"],
  ["MO", "Mechanical and Mechatronics Engineering (Additive Manufacturing)"],
  ["SB", "Computer Science and Engineering (Internet of Things and Cyber Security including Block Chain Technology)"],
  ["EN", "ENVIRONMENTAL ENGINEERING"],
  ["BC", "Bio Technology and Bio Chemical Engineering"],
  ["IN", "INDUSTRIAL ENGINEERING AND MANAGEMENT"]
]);